export const GoogleFormOptionsModalId: string = 'GoogleFormOptionsModalId';
